export const TITKTOK_URL = 'cite="https://www.tiktok.com';
export const TITKTOK_EMBED_URL = 'https://www.tiktok.com/embed.js';
export const TENOR_URL = 'https://tenor.com';
export const TENOR_EMBED_URL = 'https://tenor.com/embed.js';
export const RETOOL_URL =
  'https://xqmath.retool.com/apps/dab36494-4879-11ec-ab5e-0fdea9dde58c/XQ%20Math%20Admin%20Panel?_releaseVersion=latest';
export const FAQ_URL = 'https://xqinstitutehelp.zendesk.com/';
export const DOMAINS_FOR_WHITELIST =
  'content.xqmath.com, student.xqmath.com, teacher.xqmath.com, googleapis.com, o468541.ingest.sentry.io, api.stream-io-api.com, api.stream-io-api.com/api/v1.0/, us-east-api.stream-io-api.com/api/v1.0/, us-central1-xq-math-v2.cloudfunctions.net, https://www.desmos.com/api';
